import React from 'react';



const logos = [
  {
    name: "Visa",
    image: '/Multimedia/LogosTarjeta/Visa_Logo.png',
    width:53,
    height:16
  },
  {
    name: "MasterCard",
    image:'/Multimedia/LogosTarjeta/MasterCard_logo.png',
    width:51,
    height:38
  },
  {
    name: "America Express",
    image:'/Multimedia/LogosTarjeta/American_Express_logo.png',
    width:40,
    height:40
  },
  {
    name: "Diners Club",
    image:'/Multimedia/LogosTarjeta/Diners_Club_Logo.png',
    width:38,
    height:30
  },
  {
    name: "JCB",
    image:'/Multimedia/LogosTarjeta/JCB_Cards.png',
    width:38,
    height:30
  },
  {
    name: "Verified Visa",
    image:'/Multimedia/LogosTarjeta/verified-by-visa.png',
    width:70,
    height:32
  },
  {
    name: "MasterCard SecureCode",
    image:'/Multimedia/LogosTarjeta/mastercard-securecode.png',
    width:70,
    height:32
  },

];

function logosCards() {

  return(
    <div style={{  display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      
        {
          logos.map(logo => (
                   <div key={logo.name} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>  <img src={logo.image}  style={{ width: logo.width, height: logo.height,margin:20 }}></img> </div>   
          ))
        }
      
    </div>
  )
}

export default logosCards;